module.exports = __webpack_public_path__ + "static/07-bc6a937082f618a4cb98bfb04809b4cc.jpg";